import { useEffect } from "react";
import ReactGA from "react-ga4";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import PickupStudentBookingMobile from "./pickupStudentBookingMobile";
import { BrowserView, MobileView } from "react-device-detect";
const PickupStudentBookingComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("ScanPickupStudent");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Scan Pickup Student",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <PickupStudentBookingMobile></PickupStudentBookingMobile>
      </BrowserView>
      <MobileView>
        <PickupStudentBookingMobile></PickupStudentBookingMobile>
      </MobileView>
    </>
  );
};

export default PickupStudentBookingComponent;
